module.exports = __webpack_public_path__ + "static/media/puf_garage.71cc1fab.jpeg";